import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { integrationQueryKeys } from "@/integration/data/integrationQueryKeys";

export function useTargetingNotificationSettings() {
  const { app } = useEnvironment();

  const slackQuery = useQuery({
    queryKey: integrationQueryKeys.appSlackNotificationSettings(app.id),
    queryFn: () =>
      api
        .get<"/apps/:appId/notification-settings/slack">(
          `/apps/${app.id}/notification-settings/slack`,
        )
        .then((res) => res.data),
    enabled: Boolean(app),
    staleTime: 1000 * 2,
  });

  const linearQuery = useQuery({
    queryKey: integrationQueryKeys.appLinearNotificationSettings(app.id),
    queryFn: () =>
      api
        .get<"/apps/:appId/notification-settings/linear">(
          `/apps/${app.id}/notification-settings/linear`,
        )
        .then((res) => res.data),
    enabled: Boolean(app),
    staleTime: 1000 * 2,
  });

  return {
    data:
      slackQuery.data && linearQuery.data
        ? {
            slack: slackQuery.data,
            linear: linearQuery.data,
          }
        : undefined,
    isLoading: slackQuery.isLoading || linearQuery.isLoading,
    isError: slackQuery.isError || linearQuery.isError,
    error: slackQuery.error ?? linearQuery.error,
  };
}
